import { useState } from "react"
import { toast } from "react-toastify"
import axiosInstance from "../../../services/axios-client"
import { useNavigate } from "react-router-dom"

const useCalibration = () => {
    const [payload, setPayload] = useState({})
    const [actualScore, setActualScore] = useState({
        PTTScore: '',
        PATScore: '',
        Score360: '',
        ActualScore: '',
        ActualRating: undefined,
        Y1Rating: undefined,
        Y2Rating: undefined
    })
    const [employee, setEmployee] = useState()
    const [employeeSelect, setEmployeeSelect] = useState()
    const [allUsers, setAllUsers] = useState()
    const [allSpmo, setAllSpmo] = useState()
    const [userValue, setUserValue] = useState()
    const [projectPhases, setProjectPhases] = useState([])
    const [isSaving, setIsSaving] = useState(false)
    const navigate = useNavigate()

    const getAllUsers = async () => {
        try {
            let res = await axiosInstance.get('/auth/users/all')
            if (res.status === 200) {
                let users = []
                let data = {}
                let spmo = []
                for (const user of res.data.data) {
                    // if (user.Email === 'harfa.dewi@techconnect.co.id' || user.Email === 'muh.nasir@beraucoal.co.id') {
                    //     console.log("data kak tossa = ", user)
                    // }
                    users.push({
                        'label': user.Nik + " " + user.Name + " " + user.Division + " - " + user.BusinessUnitName,
                        'value': user.Nik + " " + user.Name + " " + user.Division + " - " + user.BusinessUnitName
                    })
                    data[user.Nik + " " + user.Name + " " + user.Division + " - " + user.BusinessUnitName] = user.ID
                    if (user.Roles) {
                        if (user.Roles.includes('spmo')) {
                            spmo.push({
                                'label': user.Nik + " " + user.Name + " " + user.Division + " - " + user.BusinessUnitName,
                                'value': user.Nik + " " + user.Name + " " + user.Division + " - " + user.BusinessUnitName
                            })
                        }
                    }
                }
                setUserValue(data)
                setEmployeeSelect(users)
                setAllUsers(users)
                setAllSpmo(spmo)
            }
        } catch (error) {
            if (error.response) {
                toast.error(error?.response?.data?.status?.description)
            } else if (error.message) {
                toast.error(error.message)
            } else {
                toast.error(error)
            }
        }
    }

    const getProjectPhases = async (id) => {
        try {
            let res = await axiosInstance.get(`/auth/projects/${id}`)
            if (res.status === 200) {
                setProjectPhases(res.data.data.ProjectPhases)
                let data = {}
                for (const projectPhase of res.data.data.ProjectPhases) {
                    data[projectPhase.ID] = {
                        Spmo: [],
                    }
                }
                setPayload(data)
            }
        } catch (error) {
            if (error.response) {
                toast.error(error?.response?.data?.status?.description)
            } else if (error.message) {
                toast.error(error.message)
            } else {
                toast.error(error)
            }
        }
    }

    const handleSelectedEmployee = (value) => {
        setEmployee(value)
    }

    const handleChangeActualScore = (e) => {
        setActualScore((prevPayload) => ({ ...prevPayload, [e.target.name]: e.target.value }))
    }

    const handleDataActualRating = (value) => {
        setActualScore((prevPayload) => ({ ...prevPayload, ActualRating: value }))
    }

    const handleDataY1Rating = (value) => {
        setActualScore((prevPayload) => ({ ...prevPayload, Y1Rating: value }))
    }

    const handleDataY2Rating = (value) => {
        setActualScore((prevPayload) => ({ ...prevPayload, Y2Rating: value }))
    }

    const handleData = (userName, projectPhaseID, type) => {
        let data = { ...payload }
        if (type === "calibrator") {
            data[projectPhaseID].Calibrator = userName
        } else {
            if (userName.length <= 3) {
                data[projectPhaseID].Spmo = userName
            }
        }
        setPayload(data)
    }

    const getActualScore = async (projectID, employeeID) => {
        try {
            let res = await axiosInstance.get(`/auth/actual-scores/${projectID}/${employeeID}`)
            if (res.status === 200) {
                setActualScore(res.data.data)

                let employeeData = res.data.data.Employee.Nik + " " + res.data.data.Employee.Name + " " + res.data.data.Employee.Division + " - " + res.data.data.Employee.BusinessUnit.Name
                setEmployee(employeeData)
            }
        } catch (error) {
            if (error.response) {
                toast.error(error?.response?.data?.status?.description)
            } else if (error.message) {
                toast.error(error.message)
            } else {
                toast.error(error)
            }
        }
    }

    const getCalibrationData = async (projectID, employeeID, projectPhases) => {
        try {
            let res = await axiosInstance.get(`/auth/calibrations-project-employee/${projectID}/${employeeID}`)
            if (res.status === 200) {
                let data = {}
                for (const projectPhase of projectPhases) {
                    data[projectPhase.ID] = {
                        Spmo: [],
                    }
                }

                let employeeData
                for (const calibration of res.data.data) {
                    let dataSpmo = []
                    if (calibration.SpmoID) {
                        dataSpmo.push(calibration.Spmo.Nik + " " + calibration.Spmo.Name + " " + calibration.Spmo.Division + " - " + calibration.Spmo.BusinessUnit.Name)
                    }
                    if (calibration.Spmo2ID) {
                        dataSpmo.push(calibration.Spmo2.Nik + " " + calibration.Spmo2.Name + " " + calibration.Spmo2.Division + " - " + calibration.Spmo2.BusinessUnit.Name)
                    }
                    if (calibration.Spmo3ID) {
                        dataSpmo.push(calibration.Spmo3.Nik + " " + calibration.Spmo3.Name + " " + calibration.Spmo3.Division + " - " + calibration.Spmo3.BusinessUnit.Name)
                    }

                    data[calibration.ProjectPhase.ID] = {
                        Calibrator: calibration.Calibrator.Nik + " " + calibration.Calibrator.Name + " " + calibration.Calibrator.Division + " - " + calibration.Calibrator.BusinessUnit.Name,
                        Spmo: dataSpmo
                    }
                    
                    employeeData = calibration.Employee.Nik + " " + calibration.Employee.Name + " " + calibration.Employee.Division + " - " + calibration.Employee.BusinessUnit.Name
                }
                setPayload(data)

                setEmployee(employeeData)
            }
        } catch (error) {
            if (error.response) {
                toast.error(error?.response?.data?.status?.description)
            } else if (error.message) {
                toast.error(error.message)
            } else {
                toast.error(error)
            }
        }
    }

    const onSubmit = async (e, projectID) => {
        try {
            e.preventDefault()
            setIsSaving(true)
            if (employee) {
                if (actualScore.ActualScore && actualScore.ActualRating) {
                    let newPayload = []
                    for (const [projectPhaseId, value] of Object.entries(payload)) {
                        if (value.Calibrator && value.Spmo) {
                            let data = {
                                ProjectID: projectID,
                                ProjectPhaseID: projectPhaseId,
                                EmployeeID: userValue[employee],
                                CalibratorID: userValue[value.Calibrator],
                            }

                            if (value.Spmo.length >= 1) {
                                data["SpmoID"] = userValue[value.Spmo[0]]
                            }
                            if (value.Spmo.length >= 2) {
                                data["Spmo2ID"] = userValue[value.Spmo[1]]
                            }
                            if (value.Spmo.length === 3) {
                                data["Spmo3ID"] = userValue[value.Spmo[2]]
                            }
                            newPayload.push(data)
                        }
                    }

                    if (newPayload.length > 0) {
                        let payloadData = {
                            CalibrationDataForms: newPayload,
                            ActualScore: parseFloat(actualScore.ActualScore),
                            ActualRating: actualScore.ActualRating,
                            Y1Rating: actualScore.Y1Rating,
                            Y2Rating: actualScore.Y2Rating,
                            PTTScore: parseFloat(actualScore.PTTScore),
                            PATScore: parseFloat(actualScore.PATScore),
                            Score360: parseFloat(actualScore.Score360),
                        }

                        let res = await axiosInstance.post('/auth/calibrations-user', payloadData)
                        if (res.status === 200) {
                            toast.success("Successfully create/update Calibration Data")
                            navigate(-1)
                        }
                    } else {
                        toast.error("You should fill at least 1 data for calibrator")
                    }
                } else {
                    toast.error("You should fill all data for Actual Score")
                }

            } else {
                toast.error("You should input employee")
            }
        } catch (error) {
            if (error.response) {
                toast.error(error?.response?.data?.status?.description)
            } else if (error.message) {
                toast.error(error.message)
            } else {
                toast.error(error)
            }
        } finally {
            setIsSaving(false)
        }
    }

    return {
        getAllUsers,
        employeeSelect,
        allUsers,
        getProjectPhases,
        projectPhases,
        payload,
        handleSelectedEmployee,
        handleData,
        getCalibrationData,
        employee,
        onSubmit,
        handleChangeActualScore,
        actualScore,
        getActualScore,
        handleDataActualRating,
        handleDataY1Rating,
        handleDataY2Rating,
        isSaving,
        allSpmo,
    }
}

export default useCalibration